import { render, staticRenderFns } from "./currentProjects.vue?vue&type=template&id=0a3f7478&scoped=true"
import script from "./currentProjects.vue?vue&type=script&lang=js"
export * from "./currentProjects.vue?vue&type=script&lang=js"
import style0 from "./currentProjects.vue?vue&type=style&index=0&id=0a3f7478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f7478",
  null
  
)

export default component.exports